/**
 * This file is auto-generated from BodyWeight.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */
export const label = lang => {
    switch (lang) {
        case 'en':
            return 'Weight';
        case 'pl':
            return 'Waga';
    }
};
export const unitLabel = lang => {
    switch (lang) {
        case 'en':
            return 'Weight unit';
        case 'pl':
            return 'Jednostka wagi';
    }
};
//# sourceMappingURL=BodyWeight.loc.js.map